import Axios from 'src/utils/axiosConfig';
import {
  SET_PRODUCTS, SET_ERROR, LOADING_PRODUCTS,
} from '../types';

const getProducts = (queryLatest) => async (dispatch) => {
  const size = queryLatest ? 5 : 50;

  dispatch({ type: LOADING_PRODUCTS, value: true });

  try {
    const result = await Axios.get(`/products/filter/all?page=1&pageSize=${size}`);
    dispatch({ type: LOADING_PRODUCTS, value: false });
    dispatch({ type: SET_PRODUCTS, products: result.data.data });
  } catch (error) {
    dispatch({ type: LOADING_PRODUCTS, value: false });
    dispatch({ type: SET_ERROR, error: error.message });
  }
};

export { getProducts };
